import { useMap } from '@vis.gl/react-google-maps'
import { useEffect, useState } from 'react'
import { useHits } from './Context'
import { useAppSelector } from '../store/hooks'
import { t } from '../../../../assets/utils/algolia/algoliaLocalization'
import MarkerWithPopup from '../../../../assets/frontend/js/components/location-map/MarkerWithPopup'
import type { MarkerItem } from '../../../../assets/frontend/js/components/location-map/types'
import type { LocationUrlConfig } from '../../../../assets/frontend/js/components/location-map/urlUtils'

export default function LocationsMapMarkers() {
  const { items } = useHits()
  const config = useAppSelector((state) => state.config)
  const map = useMap()
  const [selectedId, setSelectedId] = useState<string | null>(null)

  const urlConfig: LocationUrlConfig = {
    redirectBaseUrl: config.redirectBaseUrl,
    microchurchSlug: config.microchurchSlug
  }

  // Close popup when clicking on map
  useEffect(() => {
    if (!map) return

    const listener = map.addListener('click', () => {
      setSelectedId(null)
    })

    return () => {
      google.maps.event.removeListener(listener)
    }
  }, [map])

  const markerItems: MarkerItem[] = items
    .filter((item) => item._geoloc?.lat !== undefined && item._geoloc?.lng !== undefined)
    .map((item) => ({
      objectID: item.objectID ?? '',
      name: t(item.name, { fallback: 'any' }) ?? '',
      status: item.status ?? '',
      slug: t(item.slug, { fallback: 'any' }) ?? '',
      _geoloc: {
        lat: item._geoloc?.lat ?? 0,
        lng: item._geoloc?.lng ?? 0
      }
    }))

  return (
    <>
      {markerItems.map((item) => (
        <MarkerWithPopup
          key={item.objectID}
          item={item}
          isSelected={selectedId === item.objectID}
          onSelect={() => setSelectedId(item.objectID)}
          onClose={() => setSelectedId(null)}
          urlConfig={urlConfig}
        />
      ))}
    </>
  )
}
